import { logWrapper } from '../../utils';

export default {
  linkedDocumentsController: [
    'runtimeConstant',
    '$scope',
    'docs',
    '$controller',
    function (runtimeConstant, $scope, docs, $controller) {
      'use strict';

      function viewSelected() {
        $scope.docs.filter(function (c) {
          return c.selected === true;
        });

        if (!$scope.popupsBlocked) {
          $scope.loadDocuments();
          $scope.$close();
        }
      }

      function closeModal() {
        var selected = $scope.Selected();

        for (var i = 0; i < selected.length; i++) {
          selected[i].selected = false;
        }

        $scope.loadDocuments();
        $scope.$close();
      }

      function Selected() {
        //Busca os documentos selecionados no modal
        var selected = $scope.docs.filter(function (c) {
          return c.selected === true;
        });
        return selected;
      }

      function downloadCan() {
        //chama a função do base.documents.controller que verifica se pode fazer download
        var selected = $scope.Selected();
        var can = $scope.canDownload(selected);

        return can;
      }

      function downloadItem(item) {
        var selected = [];
        selected.push(item);
        return $scope.canDownload(selected);
      }

      function Download() {
        //chama a função do base.documents.controller que faz o download dos documentos selecionados
        var selected = $scope.Selected();
        $scope.download(false, selected);

        for (var i = 0; i < selected.length; i++) {
          selected[i].selected = false;
        }

        $scope.loadDocuments();
        $scope.$close();
      }

      function allSelected(value) {
        if (arguments.length) {
          $scope.docs.forEach(function (c) {
            c.selected = value;
          });

          return value;
        } else {
          if ($scope.docs === undefined || $scope.docs === null) {
            return false;
          }

          return $scope.docs.every(function (c) {
            return c.selected === true;
          });
        }
      }

      function toggleSelectAll() {
        var select = !$scope.allSelected();

        $scope.docs.forEach(function (c) {
          c.selected = select;
        });
      }

      function run() {
        try {
          $controller('documentsController', {
            $scope: $scope,
          });

          $scope.docs = docs;
          $scope.popupsBlocked = false;

          $scope.viewSelected = logWrapper(
            viewSelected,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.closeModal = logWrapper(
            closeModal,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.Selected = logWrapper(
            Selected,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.downloadCan = logWrapper(
            downloadCan,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.downloadItem = logWrapper(
            downloadItem,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.Download = logWrapper(
            Download,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.allSelected = logWrapper(
            allSelected,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.toggleSelectAll = logWrapper(
            toggleSelectAll,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
